module.exports = __webpack_public_path__ + "img/request_references.067239f5.svg";